import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { API, UserContext } from "@/App";
import { MailCheck } from "lucide-react";
import { toast } from "sonner";

export default function VerifyEmail() {
  const location = useLocation();
  const navigate = useNavigate();
  const { account, refreshSession } = useContext(UserContext);
  const [status, setStatus] = useState("checking");
  const token = new URLSearchParams(location.search).get("token");

  useEffect(() => {
    if (!token) { setStatus("waiting"); return; }
    axios.post(`${API}/auth/verify-email`, { token })
      .then(async () => { setStatus("verified"); toast.success("Email verified!"); await refreshSession(); })
      .catch(e => { setStatus("error"); toast.error(e.response?.data?.detail || "Verification link is invalid or expired."); });
  }, [token, refreshSession]);

  const continueSetup = () => {
    navigate("/billing");
  };

  return <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "#FFF9F0" }}>
    <div className="open-book max-w-md w-full p-8 text-center">
      <MailCheck className="w-12 h-12 mx-auto mb-4" style={{ color: "#0284C7" }} />
      {status === "checking" && <><h1 className="font-heading text-2xl font-bold" style={{ color: "#4A3224" }}>Verifying your email...</h1><p className="mt-3" style={{ color: "#7A5946" }}>Just a moment.</p></>}
      {status === "waiting" && <><h1 className="font-heading text-2xl font-bold" style={{ color: "#4A3224" }}>Check your email</h1><p className="mt-3" style={{ color: "#7A5946" }}>We sent you a verification link. Open it to finish setting up Treasure Tome.</p><button onClick={() => navigate("/welcome")} className="tt-btn tt-btn-ocean w-full py-3 mt-6">Back to Sign In</button></>}
      {status === "verified" && <><h1 className="font-heading text-2xl font-bold" style={{ color: "#4A3224" }}>You're verified!</h1><p className="mt-3" style={{ color: "#7A5946" }}>Next, start your 7-day free trial.</p><button onClick={continueSetup} className="tt-btn tt-btn-ocean w-full py-3 mt-6">Choose My Plan</button></>}
      {status === "error" && <><h1 className="font-heading text-2xl font-bold" style={{ color: "#4A3224" }}>That link didn't work</h1><p className="mt-3" style={{ color: "#7A5946" }}>It may have expired. You can request a new account verification email by signing in.</p><button onClick={() => navigate("/welcome")} className="tt-btn tt-btn-ocean w-full py-3 mt-6">Back to Sign In</button></>}
    </div>
  </div>;
}
